import React from 'react';
import { Flame } from 'lucide-react';
import './StreakBadge.css';

export default function StreakBadge({ streak, onClick }) {
  // Determine streak tier for styling
  // Tiers based on habit formation milestones: 7 days (week), 30 days (month), 90 days (3 months)
  const getStreakTier = (streakCount) => {
    if (streakCount === 0) return 'none';
    if (streakCount <= 7) return 'starter';
    if (streakCount <= 30) return 'hot';
    if (streakCount < 90) return 'fire';
    return 'legendary';
  };

  // Get tooltip message based on streak
  const getTooltipMessage = (streakCount) => {
    if (streakCount === 0) return 'Start your streak today!';
    if (streakCount === 1) return '1 day streak! Keep it going!';
    if (streakCount <= 7) return `${streakCount} day streak! Building the habit! 🔥`;
    if (streakCount <= 30) return `${streakCount} day streak! Monthly milestone! 🔥🔥`;
    if (streakCount < 90) return `${streakCount} day streak! Unstoppable! 🔥🔥🔥`;
    return `${streakCount} day streak! LEGENDARY! 3+ months! 🔥🔥🔥`;
  };

  const tier = getStreakTier(streak);
  const tooltipText = getTooltipMessage(streak);

  return (
    <button
      className={`streak-badge streak-tier-${tier}`}
      onClick={onClick}
      title={tooltipText}
      aria-label={`${streak} day streak`}
    >
      <Flame
        size={18}
        className="streak-icon"
        strokeWidth={2.5}
      />
      <span className="streak-number">{streak}</span>
    </button>
  );
}
